import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthenticationMethod, Signer, User } from '@app/models';

export type ModalResult = { option: AuthenticationMethod };
export interface ModalPublicProperties {
  signer?: Signer;
  email?: string;
}

@Component({
  selector: 'app-auth--biometric-login-modal',
  templateUrl: './auth-biometric-login-modal.component.html',
  styleUrls: ['./auth-biometric-login-modal.component.scss'],
  standalone: false
})
export class AuthBiometricLoginModalComponent implements ModalPublicProperties {
  @Input() signer: Signer;
  @Input() email: string;

  constructor(public modal: NgbActiveModal) {}

  selectBiometric() {
    this.modal.close({ option: AuthenticationMethod.Biometric });
  }

  selectEmail() {
    this.modal.close({ option: AuthenticationMethod.Email });
  }
}
